export default __webpack_public_path__ + "static/media/calculatorLight.da247aac.svg";